var render = function render(_c,_vm){return _c('div',{staticClass:"d-flex flex-wrap"},[_vm._t("default"),_c('v-spacer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }